export class ZvStorage implements Storage {
  private static _local: ZvStorage;

  public static get local(): Storage {
    if (!ZvStorage._local) {
      ZvStorage._local = createOrDummy(() => {
        if (!localStorage) {
          throw new Error('localStorage not available');
        }

        return localStorage;
      });
    }
    return ZvStorage._local;
  }

  public get length(): number {
    return this.storage.length;
  }

  constructor(private storage: Storage) {}

  public clear(): void {
    try {
      this.storage.clear();
    } catch {
      /* empty */
    }
  }
  public getItem(key: string): string | null {
    try {
      return this.storage.getItem(key);
    } catch {
      return null;
    }
  }
  public key(index: number): string | null {
    try {
      return this.storage.key(index);
    } catch {
      return null;
    }
  }
  public removeItem(key: string): void {
    try {
      this.storage.removeItem(key);
    } catch {
      /* empty */
    }
  }
  public setItem(key: string, value: string): void {
    try {
      this.storage.setItem(key, value);
    } catch {
      /* empty */
    }
  }
}

function createOrDummy(createFn: () => Storage) {
  let storage: Storage | null = null;
  try {
    storage = createFn();
  } catch {
    // z.B. Im Inkognito Modus in einem iframe mit anderer Domain wie der Parent geht localStorage nicht.
    storage = {
      clear: () => {},
      getItem: () => null,
      key: () => null,
      length: 0,
      removeItem: () => {},
      setItem: () => {},
    };
  }
  return new ZvStorage(storage);
}
